import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { DatePicker, RuTertiaryButton } from '@silverrailtech/srtlibrary';
import messages from '../../messagesOuigoRefunds';
import inlineStyles, {
	DateRangeWrapper,
	DatePickerGlobalStyle,
	ResultCount,
	ToolbarActions,
	ToolbarLabel,
	ToolbarWrapper,
} from './styles';

const VouchersToolbar = ({
	fromDate,
	toDate,
	onFromDateChange,
	onToDateChange,
	onApply,
	resultStart,
	resultEnd,
	resultTotal,
}) => (
	<ToolbarWrapper>
		<DatePickerGlobalStyle />
		<DateRangeWrapper>
			<div
				className="ouigo-refunds-date-picker ouigo-refunds-date-picker-start"
				style={inlineStyles.field}
			>
				<ToolbarLabel>
					<FormattedMessage {...messages.lblRangeFrom} />
				</ToolbarLabel>
				<DatePicker
					id="ouigo-refunds-range-from"
					selected={fromDate}
					onChange={onFromDateChange}
					maxDate={toDate || new Date()}
					placeholderText="DD / MM / YYYY"
					dateFormat="dd / MM / yyyy"
					showDisabledMonthNavigation
					disabledKeyboardNavigation
				/>
			</div>
			<div
				className="ouigo-refunds-date-picker ouigo-refunds-date-picker-end"
				style={inlineStyles.field}
			>
				<ToolbarLabel>
					<FormattedMessage {...messages.lblRangeTo} />
				</ToolbarLabel>
				<DatePicker
					id="ouigo-refunds-range-to"
					selected={toDate}
					onChange={onToDateChange}
					minDate={fromDate}
					maxDate={new Date()}
					placeholderText="DD / MM / YYYY"
					dateFormat="dd / MM / yyyy"
					showDisabledMonthNavigation
					disabledKeyboardNavigation
				/>
			</div>
		</DateRangeWrapper>
		<ToolbarActions style={inlineStyles.actions}>
			<RuTertiaryButton color="subt_1" onClick={onApply} type="button">
				<FormattedMessage {...messages.lblApply} />
			</RuTertiaryButton>
			<ResultCount>
				<FormattedMessage
					{...messages.lblShowingResults}
					values={{
						resultStart,
						resultEnd,
						resultTotal,
					}}
				/>
			</ResultCount>
		</ToolbarActions>
	</ToolbarWrapper>
);

VouchersToolbar.propTypes = {
	fromDate: PropTypes.instanceOf(Date),
	toDate: PropTypes.instanceOf(Date),
	onFromDateChange: PropTypes.func.isRequired,
	onToDateChange: PropTypes.func.isRequired,
	onApply: PropTypes.func.isRequired,
	resultStart: PropTypes.number.isRequired,
	resultEnd: PropTypes.number.isRequired,
	resultTotal: PropTypes.number.isRequired,
};

export default VouchersToolbar;
